import React, { Fragment } from 'react';
import {
    Bar,
    BarChart,
    Area,
    AreaChart,
    Line,
    LineChart,
    ResponsiveContainer,
} from 'recharts';
import {
    data,
    data1,
    data2,
} from './data';
import ChartCard from 'components/dashboard/Common/ChartCard';
import ContainerHeader from 'components/ContainerHeader/index';
import IntlMessages from 'util/IntlMessages';
import Gantt from 'components/Gantt';
import { mapToGanttData } from 'services/portfolioService';
import SimpleModal from 'components/simpleModal';
import { getStorageItem, SELECTED_PORTFOLIO } from 'services/Authentication';
import ValueStreamDrillDown from 'components/agileDrillDowns/valueStreamDrillDown';
import ProductDrillDown from 'components/agileDrillDowns/productDrillDown';
import CircularProgress from 'components/CircularProgress';

// const dataGantt = {
//     data: [
//         { id: 1, text: 'Task #1', start_date: '15-04-2019', duration: 3, progress: 0.6 },
//         { id: 2, text: 'Task #2', start_date: '18-04-2019', duration: 3, progress: 0.4 }
//     ],
//     links: [
//         { id: 1, source: 1, target: 2, type: '0' }
//     ]
// };


class Component extends React.Component {

    onOptionMenuToggle = () => {
        this.setState({ menuState: !this.state.menuState });
    };
    handleRequestClose = () => {
        this.setState({ menuState: false });
    };

    constructor() {
        super();
        this.state = {
            selectedDashboardPortfolio: null,
            menuState: false,
            cardHeight: 0, // set to 60+ if you want the graphs to show on the dashboard (does take up room)
        };
    }

    async componentDidUpdate(prevProps) {
        const { selectedDashboardPortfolio } = this.props;
        if (selectedDashboardPortfolio !== prevProps.selectedDashboardPortfolio) {
            this.setState({selectedDashboardPortfolio });
        }
    }

    componentDidMount() {
        const portfolioId = getStorageItem(SELECTED_PORTFOLIO);
        console.log('componentDidMount portfolioId - '.concat(portfolioId));
        const {
            showPortfolioLoader,
            onPortfolioDashboard,
        } = this.props;
        showPortfolioLoader();
        onPortfolioDashboard(portfolioId);
    }

    render() {
        const {
            width, loader
        } = this.props;
        const { cardHeight, selectedDashboardPortfolio } = this.state;
        return (
            <div className='dashboard animated slideInUpTiny animation-duration-3'>
                <div style={{ marginLeft: '20px', marginTop: '20px' }}>
                    <ContainerHeader match={this.props.match} title={<IntlMessages id='sidebar.agile.dashboard.portfolio' />} />
                </div>

                <div className='row ml-2 mr-2 mt-2'>
                    <div className='col-lg-3 col-sm-6 col-12'>
                        <ChartCard styleName='bg-secondary text-white'>
                            <div className='chart-title'>
                                <p><IntlMessages id='portfolio.dashboard.valueStreams' /></p>
                                <div className="row">
                                    {selectedDashboardPortfolio?.valueStreams?.length > 0 ?
                                        <Fragment>
                                            <div className="col-sm-3 col-12">
                                                <h2>{selectedDashboardPortfolio?.valueStreams?.length || 0}</h2>
                                            </div>
                                            <div className="col-sm-9 col-12 text-md-right">
                                                <SimpleModal
                                                    modalTitle='Value Streams'
                                                    buttonText='More info'
                                                    modalBodyOverride={<ValueStreamDrillDown data={selectedDashboardPortfolio?.valueStreams} />}
                                                />
                                            </div>
                                        </Fragment>
                                        :
                                        <Fragment>
                                            <div className="col-sm-8 col-12 d-inline-block">
                                                <h2>{selectedDashboardPortfolio?.valueStreams?.length || 0}</h2>
                                            </div>
                                        </Fragment>
                                    }
                                </div>
                            </div>
                            <ResponsiveContainer width='100%' height={cardHeight}>
                                <BarChart data={data}>
                                    <Bar dataKey='pv' fill='white' />
                                    <Bar dataKey='uv' fill='white' />
                                </BarChart>
                            </ResponsiveContainer>
                        </ChartCard>
                    </div>

                    <div className='col-lg-3 col-sm-6 col-12'>
                        <ChartCard styleName='bg-primary text-white'>
                            <div className='chart-title'>
                                <p><IntlMessages id='portfolio.dashboard.products' /></p>
                                <div className="row">
                                    {selectedDashboardPortfolio?.products?.length > 0 ?
                                        <Fragment>
                                            <div className="col-sm-3 col-12">
                                                <h2>{selectedDashboardPortfolio?.products?.length || 0}</h2>
                                            </div>
                                            <div className="col-sm-9 col-12 text-md-right">
                                                <SimpleModal
                                                    modalTitle='Products'
                                                    buttonText='More info'
                                                    modalBodyOverride={<ProductDrillDown data={selectedDashboardPortfolio?.products} valueStreams={selectedDashboardPortfolio?.valueStreams}/>}
                                                />
                                            </div>
                                        </Fragment>
                                        :
                                        <Fragment>
                                            <div className="col-sm-8 col-12 d-inline-block">
                                                <h2>{selectedDashboardPortfolio?.products?.length || 0}</h2>
                                            </div>
                                        </Fragment>
                                    }
                                </div>
                            </div>
                            <ResponsiveContainer width='100%' height={cardHeight}>
                                <AreaChart data={data1} margin={{ top: 0, right: 0, left: 0, bottom: 0 }}>
                                    <Area type='monotone' dataKey='pv' stroke='rgba(255,255,255,0.5)'
                                        activeDot={{ r: 8 }}
                                        fillOpacity={.5}
                                        fill='white' />
                                </AreaChart>
                            </ResponsiveContainer>
                        </ChartCard>
                    </div>

                    <div className='col-lg-3 col-sm-6 col-12'>
                        <ChartCard styleName='bg-teal lighten-1 text-white'>
                            <div className='chart-title'>
                                <p><IntlMessages id='portfolio.dashboard.initiatives' /></p>
                                <h2>{selectedDashboardPortfolio?.initiatives?.length || 0}</h2>
                            </div>
                            <ResponsiveContainer width='100%' height={cardHeight}>
                                <LineChart data={data2}>
                                    <Line type='monotone' dataKey='uv' stroke='#ffffff' activeDot={{ r: 8 }} />
                                    <Line type='monotone' dataKey='pv' stroke='#ffffff' />
                                    <Line type='monotone' dataKey='amt' stroke='#ffffff' />
                                </LineChart>
                            </ResponsiveContainer>
                        </ChartCard>
                    </div>

                    <div className='col-lg-3 col-sm-6 col-12'>
                        <ChartCard styleName='bg-blue text-white'>
                            <div className='chart-title'>
                                <p><IntlMessages id='portfolio.dashboard.features' /></p>
                                <h2>{selectedDashboardPortfolio?.features?.length || 0}</h2>
                            </div>
                            <ResponsiveContainer width='100%' height={cardHeight}>
                                <LineChart data={data1}>
                                    <Line dataKey='uv' stroke='#ffffff' activeDot={{ r: 8 }} />
                                </LineChart>
                            </ResponsiveContainer>
                        </ChartCard>
                    </div>
                </div>
                <div className='row'>
                    <div className='col-12'>
                        <div style={{ marginLeft: '20px', marginBottom: '5px' }}><ContainerHeader title={<IntlMessages id='portfolio.dashboard.portfolioViewHeader' />} /></div>
                        <div className='animated slideInUpTiny animation-duration-3'>
                            <div className='gantt-container ml-2 mr-2'>
                                {loader ?
                                    <div
                                        className="loader-view-block h-100">
                                        <div className="loader-view">
                                            <CircularProgress />
                                        </div>
                                    </div>
                                    :
                                    selectedDashboardPortfolio?.initiatives?.length > 0 ?
                                        <Gantt tasks={mapToGanttData(selectedDashboardPortfolio)} width={width} />
                                        :
                                        <Fragment>
                                            <div className="dashboard animated slideInUpTiny animation-duration-3">
                                                <div className="row">
                                                    <div className="col-md-12 col-12">
                                                        <div className="jr-card jr-card-full-height ml-2 mr-2">
                                                            <h3 className="text-muted">There is no portfolio data - this may be due to the following</h3>
                                                            <h4 className="card-heading">Value Streams</h4>
                                                            <p className="sub-heading">{selectedDashboardPortfolio?.valueStreams?.length > 0 ?
                                                                'Value Streams are associated with this portfolio' : 'You have no Value Streams associated with this Portfolio'}</p>
                                                            <h4 className="card-heading">Products</h4>
                                                            {selectedDashboardPortfolio?.products?.length > 0 ?
                                                                <p className="sub-heading">Products are associated with your Value Streams</p>
                                                                :
                                                                <Fragment>
                                                                    <p className="sub-heading">You have no Products associated with your Value Streams</p>
                                                                    <p className="sub-heading">You will have to edit the Products associated with this Portfolio and select the correct Value Stream</p>
                                                                </Fragment>}
                                                            <h4 className="card-heading">Initiatives</h4>
                                                            <p className="sub-heading">{selectedDashboardPortfolio?.initiatives?.length > 0 ?
                                                                'Initiatives are associated with your Products' : 
                                                                <Fragment>
                                                                    <p className="sub-heading">You have no Initiatives associated with your Products</p>
                                                                    <p className="sub-heading">You will have to edit the Initiatives associated with this Portfolio and select the correct Product</p>
                                                                </Fragment>}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Fragment>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default Component;


// WEBPACK FOOTER //
// ./components/Agile/portfolioDashboard/component.js